import src from "IMAGE";
export default { src, width: 620, height: 620, blurWidth: 0, blurHeight: 0};
